import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Footer } from '../../components/Footer/Footer';
import { StepProps } from '../../components/OrionRiskToleranceWorkflow/OrionRiskToleranceWorkflow.meta';
import { StepId } from '../../api/useRiskToleranceWorkflowQuery';
import { Content } from '../../components/Content/Content';
import { StepCard } from '../../components/StepCard/StepCard';
import { VisualPicker } from '../../../CommonComponents/OPL/VisualPicker/VisualPicker';
import { FormValues, options, title } from './TimeHorizon.meta';
import StockMarketSVG from '../../../CommonComponents/OPL/illustrations/stock-market.svg';

export const TimeHorizon: React.FC<StepProps> = ({
  answers,
  onPrevious,
  onNext,
  onSubmit,
  progress,
}) => {
  const { handleSubmit, setValue, control } = useForm<FormValues>({
    defaultValues: {
      [StepId.TimeHorizon]: answers.timeHorizon,
    },
  });

  const onSubmitStep = ({ timeHorizon }: FormValues) => {
    onSubmit({ stepId: StepId.TimeHorizon, answer: timeHorizon });
    onNext();
  };

  return (
    <Box minWidth={864}>
      <form onSubmit={handleSubmit(onSubmitStep)}>
        <Content>
          <StepCard title={title} textAlign="left">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Controller
                control={control}
                name={StepId.TimeHorizon}
                render={({ field: { value: formValue } }) => (
                  <Box
                    display="flex"
                    flexDirection="column"
                    flexBasis={278}
                    gridGap="16"
                    role="radiogroup"
                    aria-label={title}
                  >
                    {options.map(({ label, value }) => {
                      const checked = value === formValue;

                      return (
                        <VisualPicker
                          key={value}
                          label={label}
                          onChange={() => setValue(StepId.TimeHorizon, value)}
                          checked={checked}
                        />
                      );
                    })}
                  </Box>
                )}
              />

              <StockMarketSVG width={246} height={141} />
            </Box>
          </StepCard>
        </Content>

        <Footer onPrevious={onPrevious} progress={progress} />
      </form>
    </Box>
  );
};
